import { useContext, useEffect } from 'react'
import { ModalContext } from '@nv/contexts'
import CircleCheckIcon from '@nv/images/design/circle-check-icon'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import styles from './WithdrawCandicacySuccess.module.scss'

export const WithdrawCandicacySuccess = ({ title }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { setHeaderLabel, setBtns, onClose } = useContext(ModalContext)

  const confirm = () => {
    onClose()
    navigate('/voting/voter/my-candidacy')
  }

  useEffect(() => {
    setHeaderLabel(t('Withdraw Candidacy'))
    setBtns([
      { text: t('buttons.cancel'), onClick: onClose, variant: 'secondary' },
      { text: t('buttons.approve'), onClick: () => confirm() },
    ])
  }, [])

  return (
    <div className={styles['container']}>
      <CircleCheckIcon />
      <span className={styles['title']}>{t(`You have successfully withdrawn your candidacy for ${title}`)}</span>
    </div>
  )
}
